export enum UserType {
  STUDENT = 'student',
  TEACHER = 'teacher',
  PARENT = 'parent',
  EMPLOYEE = 'employee',
}

export const getUserTypeName = (userType: UserType): string => {
  switch (userType) {
    case UserType.STUDENT:
      return '학생'
    case UserType.TEACHER:
      return '선생님'
    case UserType.PARENT:
      return '학부모님'
    case UserType.EMPLOYEE:
      return '교직원님'
    default:
      return ''
  }
}
